import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { urlToQuery } from '@/utils/inputRules'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = [
	'/auto',
	'/yidelogin',
	'/autologin',
	'/login',
	'/ddlogin',
	'/dataHunter_user',
	'/dataHunter_merchant',
	'/mobile/auto/login',
	'/ssoLogin',
	'/404'
] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
	const param = urlToQuery(window.location.search)
	if (param.tag && param.tag == 'sso') {
		// 重定向至单点登录页面
		let str = '?'
		for (const key in param) {
			if (param[key] != 'sso') {
				str += `${key}=${param[key]}&`
			}
		}
		str = str.slice(0, str.length - 1)
		window.location.href = window.location.origin + '/#/ssoLogin' + str
		return
	}
	// start progress bar
	NProgress.start()
	// set page title
	document.title = getPageTitle(to.meta.title)
	// determine whether the user has logged in
	const hasToken = getToken()
	// if (to.path != '/dataHunter_user') {
	// 	const body = document.body
	// 	console.log('body.style', body.style)
	// 	if (body.style.cssText) {
	// 		window.location.reload()
	// 	}
	// }
	if (hasToken) {
		if (to.path === '/login') {
			// if is logged in, redirect to the home page
			if (!store.state.user.userId) {
				next()
				NProgress.done()
			} else {
				next({ path: '/' })
				NProgress.done()
			}
		} else {
			// determine whether the user has obtained his permission roles through getInfo
			const hasRoles = store.getters.hasRoles
			if (hasRoles) {
				next()
			} else {
				try {
					// get user info
					// note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
					const menuIdList = await store.dispatch('user/getInfo')
					// generate accessible routes map based on roles
					const accessRoutes = await store.dispatch(
						'permission/generateRoutes',
						menuIdList
					)
					// dynamically add accessible routes
					router.addRoutes(accessRoutes)
					// hack method to ensure that addRoutes is complete
					// set the replace: true, so the navigation will not leave a history record
					next({ ...to, replace: true })
				} catch (error) {
					// remove token and go to login page to re-login
					await store.dispatch('user/resetToken')
					Message.error(error || 'Has Error')
					next(`/login?redirect=${to.path}`)
					NProgress.done()
				}
			}
		}
	}

	// // const { roles } = await store.dispatch('user/getInfo')
	// const accessRoutes = await store.dispatch('permission/generateRoutes', ['admin'])
	// router.addRoutes(accessRoutes)
	// next()
	else {
	/* has no token */

		if (whiteList.indexOf(to.path) !== -1) {
		// in the free login whitelist, go directly
			next()
		} else {
		// other pages that do not have permission to access are redirected to the login page.
			next(`/login?redirect=${to.path}`)
			NProgress.done()
		}
	}
})

router.afterEach(() => {
	// finish progress bar
	NProgress.done()
})
